import { UseQueryResult } from "@tanstack/react-query";
import { useState } from "react";

// Use a before the query and after the query to get the page amount and table data
export const useTablePaginationBeforeQuery = () => {
  const [page, setPage] = useState(1);

  const tableQueryParams = {
    page,
  };

  const pageAmountQueryParams = {
    page: 1,
  };
  return { page, setPage, tableQueryParams, pageAmountQueryParams };
};

export interface PaginatedList<T> {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Array<T>;
}

export const useTablePaginationAfterQuery = <T extends { url: string }>({
  tableQueryResult,
  pageAmountQueryResult,
  page,
  setPage,
}: {
  tableQueryResult: UseQueryResult<PaginatedList<T>, Error>;
  pageAmountQueryResult: UseQueryResult<PaginatedList<T>, Error>;
  page: number;
  setPage: (page: number) => void;
}) => {
  const tableData = (tableQueryResult.data?.results ?? []).map((item) => ({
    ...item,
    uuid: item.url,
  }));

  const total = pageAmountQueryResult.data?.count || 0;
  const amountOfItems = pageAmountQueryResult.data?.results.length || 0;
  const itemsPerPage = amountOfItems === total ? undefined : amountOfItems;
  const numPages = itemsPerPage ? Math.ceil(tableData.length / itemsPerPage) : undefined;
  const toPage1 = page > 1 ? () => setPage(1) : undefined;
  const toPrevious = page > 1 ? () => setPage(page - 1) : undefined;
  const toNext = numPages && page < numPages ? () => setPage(page + 1) : undefined;
  const toLastPage = numPages && page < numPages ? () => setPage(numPages) : undefined;

  return {
    isLoading: tableQueryResult.isLoading,
    tableData,
    itemsPerPage,
    numPages,
    toPage1,
    toPrevious,
    toNext,
    toLastPage,
  };
};
